import React, { useState } from 'react';
import {
  Box,
  Container,
  CssBaseline,
  Grid,
  Stack,
  Typography,
  FormControl,
  TextField
} from '@mui/material';
import { Link } from 'react-router-dom';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import PageHeading from '../../global/header/PageHeading';
import { useTranslation } from 'react-i18next';

const RegistrationResult = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(0);

  const radioHandler = (visible) => {
    setVisible(visible);
  };
  return (
    <>
      <PageHeading pageTitle="Registration result" />
      <Container maxWidth="lg" className="selfRegistrationContainer">
        <Box className="textCenter" pt={2}>
          <Typography variant="h5" mb={3} className="resultHead">
            {t('Digital kyc status')}
          </Typography>
          <Typography variant="body2" textAlign="center">
            {t('Your digital kyc has been completed')}
          </Typography>
        </Box>
        {/* <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }} justifyContent="center">
          <img className="backgroundLogo" src="/static/logo/main-logo.svg" alt="Background Logo" />
          <Grid item xs="12" sm="4" md="4" marginBottom={3}>
            
            <FormControl>
              <RadioGroup aria-labelledby="radio-buttons-group-label" name="radio-buttons-group">
                <FormControlLabel
                  value="cardNumber"
                  checked={visible === 1}
                  onClick={(e) => radioHandler(1)}
                  control={
                    <Radio
                      sx={{
                        color: '#3C3C4B',
                        '&.Mui-checked': {
                          color: '#F37021'
                        }
                      }}
                    />
                  }
                  label="ID card number or passport number"
                />
                {visible === 1 && (
                  <TextField
                    id="IdNumber"
                    label=""
                    inputProps={{ className: 'formControl' }}
                    fullWidth
                    placeholder="ID Card"
                    sx={{ marginBottom: '15px' }}
                  />
                )}
                <FormControlLabel
                  value="dob"
                  checked={visible === 2}
                  onClick={(e) => radioHandler(2)}
                  control={
                    <Radio
                      sx={{
                        color: '#3C3C4B',
                        '&.Mui-checked': {
                          color: '#F37021'
                        }
                      }}
                    />
                  }
                  label="Date/Month/Year of Birth"
                />

                {visible === 2 && (
                  <TextField
                    id="IdNumber"
                    label=""
                    inputProps={{ className: 'formControl' }}
                    fullWidth
                    placeholder="Date/Month/Year of Birth"
                  />
                )}
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs="12" sm="4" md="4" marginBottom={3}>
            <Typography variant="subtitle2" mb={1} className="FormLabel">
              Human or robot?
            </Typography>
            <img className="" src="/static/captcha.png" alt="Msisdn Info" />
          </Grid>
        </Grid>
        */}
        <Box mt={3} mb={3} Container justifyContent="center" alignItems="center" textAlign="center">
          <Link to="/in/selfregistration" className="mainBtn btnLink">
            {t('Back to Home')}
          </Link>
          {/* <Link to="/in/registration-successful" className="mainBtn btnLink">
            Search
          </Link> */}
        </Box>
      </Container>
    </>
  );
};

export default RegistrationResult;
